module.exports = "/_next/static/images/top-3b904cf59bff60e5fe7ccce619bacf6a.jpeg";